import React, { Component } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import TextField from "@material-ui/core/TextField";
import { Calendar } from "primereact/calendar";
import { alertActions, RejectedUserRptAction } from "../../actions/RejectedUserRptAction.js";
import { connect } from "react-redux";
import tableRequest from "../../models/tableRequest.js";
import { Toast } from "primereact/toast";
import { CSVLink } from "react-csv";
import Loader from "../../templates/Loader.js";

class RejectedUserReport extends Component {
  constructor(props) {
    super(props);
    this.tblResponse = new tableRequest();
    this.tblResponse.SortColumn = "FeedbackUpdatedOn";
    this.onPage = this.onPage.bind(this);
    this.onSort = this.onSort.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.FilterData = this.FilterData.bind(this);
    this.searchFilter = this.searchFilter.bind(this);
    this.state = {
      loading: false,
      FromDate: new Date(),
      ToDate: new Date(),
      first: 0,
      rows: 5,
      totalRecords: 0,
      globalFilter: null,
      visible: false,
      sortOrder: -1,
      datalist: [],
      audio: "",
      headers: [
        { label: "Name", key: "UserName" },
        { label: "Mobile No.", key: "MobileNo" },
        { label: "Email", key: "Email" },
        { label: "City", key: "City" },
        { label: "Reject Reason", key: "rejectReason" },
        { label: "Created Date", key: "CreatedDate" }
      ]
    };
  }

  componentDidMount() {
    const date = new Date();
    date.setHours(0, 0, 0, 0);
    date.setDate(date.getDate() - 7);
    
    this.tblResponse.FromDate = this.formatDate(date);
    this.tblResponse.ToDate = this.formatDate(new Date());
    
    this.setState({
      FromDate: date,
      ToDate: new Date(),
    });
    
    this.props.fetchApi(this.tblResponse);
    this.props.exportingData(this.tblResponse);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.FeedbackList !== this.props.FeedbackList) {
      const feedbackList = this.props.FeedbackList || [];
      let totalRows = 0;

      if (feedbackList.length > 0 && feedbackList[0]?.TotalRows) {
        totalRows = feedbackList[0].TotalRows;
      }

      this.setState({
        totalRecords: totalRows,
      });
    }
  }

  formatDate(date) {
    if (!date) return "";
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${year}/${month}/${day}`;
  }

  FilterData() {
    // Validate dates before proceeding
    if (!this.validateDates()) {
      return;
    }

    this.tblResponse.FromDate = this.formatDate(this.state.FromDate);
    this.tblResponse.ToDate = this.formatDate(this.state.ToDate);
    this.tblResponse.First = 1; // Reset to first page
    this.setState({ first: 0 });
    
    this.props.exportingData(this.tblResponse);
    this.props.fetchApi(this.tblResponse);
  }

  validateDates() {
    const { FromDate, ToDate } = this.state;

    if (!FromDate || !(FromDate instanceof Date) || isNaN(FromDate)) {
      this.showToast("error", "Error Message", "Please select valid from date.");
      return false;
    }

    if (!ToDate || !(ToDate instanceof Date) || isNaN(ToDate)) {
      this.showToast("error", "Error Message", "Please select valid to date.");
      return false;
    }

    if (FromDate > ToDate) {
      this.showToast("error", "Error Message", "From date must be less than or equal to to date.");
      return false;
    }

    return true;
  }

  showToast(severity, summary, detail) {
    this.toast.show({ severity, summary, detail, life: 3000 });
  }

  handleChange(event) {
    const { name, value } = event.target;
    
    if (name === "FromDate" || name === "ToDate") {
      if (!value || !(value instanceof Date) || isNaN(value)) {
        this.showToast("error", "Error Message", `Please select valid ${name.toLowerCase()}.`);
        return;
      }
    }

    this.setState({ [name]: value });
  }

  getLazyLoadingValues(event) {
    this.setState({ 
      rows: event.rows, 
      first: event.first 
    });
    
    this.tblResponse.PageSize = event.rows;
    this.tblResponse.First = event.first + 1;
    this.tblResponse.IsActive = true;
    this.tblResponse.SearchValue = event.globalFilter ? event.globalFilter : "";
    this.tblResponse.SortOrder = event.sortOrder === 1 ? "ASC" : "DESC";
    this.tblResponse.FromDate = this.formatDate(this.state.FromDate);
    this.tblResponse.ToDate = this.formatDate(this.state.ToDate);
  }

  onPage(event) {
    this.props.loadingData(true);

    setTimeout(() => {
      this.getLazyLoadingValues(event);
      this.props.fetchApi(this.tblResponse);
    }, 250);
  }

  onSort(event) {
    this.props.loadingData(true);
    
    const sortField = event.sortField === "CreatedDate" ? "CreatedDt" : event.sortField;
    this.tblResponse.SortColumn = sortField || "";
    this.tblResponse.SortOrder = event.sortOrder === 1 ? "ASC" : "DESC";
    
    this.setState({ sortOrder: event.sortOrder });
    this.props.fetchApi(this.tblResponse);
  }

  searchFilter(e) {
    const searchValue = e.target.value;
    this.tblResponse.SearchValue = searchValue;
    this.tblResponse.First = 1; // Reset to first page when searching
    this.setState({ first: 0 });
    
    this.props.fetchApi(this.tblResponse);
    this.props.exportingData(this.tblResponse);
  }

  render() {
    const { FromDate, ToDate, rows, first, totalRecords, headers } = this.state;
    const { FeedbackList, List, loading } = this.props;

    return (
      <div className="datatable-filter-demo">
        <Toast ref={(el) => (this.toast = el)} />
        <Loader loader={loading} />
        
        <div className="row mb-3">
          <div className="col-md-3">
            <h4>Rejected User Report</h4>
          </div>
          <div className="col-md-9">
            <div className="row text-right">
              <div className="col-md-3">
                <Calendar
                  placeholder="From Date"
                  name="FromDate"
                  showIcon={true}
                  value={FromDate}
                  onChange={this.handleChange}
                  dateFormat="mm/dd/yy"
                />
              </div>
              <div className="col-md-3">
                <Calendar
                  placeholder="To Date"
                  name="ToDate"
                  showIcon={true}
                  value={ToDate}
                  onChange={this.handleChange}
                  dateFormat="mm/dd/yy"
                />
              </div>
              <div className="col-md-3 text-center">
                <button
                  type="button"
                  onClick={this.FilterData}
                  className="btn btn-primary p-2 ml-3 buttone"
                >
                  Submit
                </button>
                &nbsp;
                <CSVLink
                  data={List || []}
                  headers={headers}
                  filename={"Rejected User report.csv"}
                  target="_blank"
                >
                  <button className="btn btn-success p-2 mr-2 buttone">
                    Export
                  </button>
                </CSVLink>
              </div>
              <div className="col-md-3">
                <TextField
                  id="standard-basic"
                  size="small"
                  variant="outlined"
                  className="fullwidth"
                  label="Search"
                  onInput={this.searchFilter}
                />
              </div>
            </div>
          </div>
        </div>
        
        <div className="card">
          <DataTable
            value={FeedbackList || []}
            scrollable
            responsive={true}
            emptyMessage="No data found."
            sortMode="single"
            paginator={true}
            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
            rows={rows}
            style={{ width: "100%" }}
            rowsPerPageOptions={[5, 10, 20, 50, 100]}
            totalRecords={totalRecords}
            lazy={true}
            first={first}
            onPage={this.onPage}
            onSort={this.onSort}
            loading={loading}
            ref={(el) => { this.dt = el; }}
          >
            <Column field="UserName" header="Name" sortable></Column>
            <Column field="MobileNo" header="Mobile No." sortable></Column>
            <Column field="Email" header="Email" sortable></Column>
            <Column field="City" header="City" sortable></Column>
            <Column field="rejectReason" header="Reject Reason" sortable></Column>
            <Column field="CreatedDate" header="Created Date" sortable></Column>
          </DataTable>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    FeedbackList: state.RejectedUserRpt?.items || [],
    List: state.RejectedUserRpt?.exportitems || [],
    loading: state.RejectedUserRpt?.loading || false,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchApi: (obj) => {
      dispatch(RejectedUserRptAction.getAll(obj));
    },
    loadingData: (isLoading) => dispatch(RejectedUserRptAction.loadingData(isLoading)),
    exportingData: (obj) => dispatch(RejectedUserRptAction.exportData(obj)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(RejectedUserReport);